/**
 * Formats a user identity for the workbench header as "name (role)", falling
 * back to name-only when role is absent or blank, and to "" when name is absent.
 */
export function formatUserDisplayName(name?: string, role?: string): string {
  const trimmedName = name?.trim() ?? "";
  const trimmedRole = role?.trim() ?? "";

  if (!trimmedName) {
    return "";
  }

  if (!trimmedRole) {
    return trimmedName;
  }

  return `${trimmedName} (${trimmedRole})`;
}
